import DataSourceListDto from "../../../dtos/datasourcemodule/DataSourceListDto";
import PathListDto from "../../../dtos/pathmodule/PathListDto";

class GetDataSourcesResult {
    DataSources: DataSourceListDto[];
    PathDataTables: PathListDto[];
    constructor(dataSources: DataSourceListDto[], pathDataTables: PathListDto[]) {
        this.DataSources = dataSources;
        this.PathDataTables = pathDataTables;
    }
}

export default GetDataSourcesResult;
